/* eslint-disable no-shadow */
import { Action } from '@reduxjs/toolkit';
import { StateObservable, combineEpics } from 'redux-observable';
import { Observable, from, of } from 'rxjs';
import {
  map, switchMap, first, filter, catchError, tap, ignoreElements,
} from 'rxjs/operators';

import { NAVIGATION_METHODS } from '@ezugi/constants';
import { ss } from '@ezugi/utils';

import { EVENTS } from '../../../constants/postMessage';
import { logDevelopmentError } from '../../../util/logDevelopmentError';
import { postMessage } from '../../../util/postMessage';
import { menuActions } from '../../actions';
import { tableIdSelector, authSelector, isEvoWrappedSelector } from '../../selectors';
import { isAuthParamsErrorSelector } from '../../selectors/error';
import { goHome } from './utils';

import type { RootState } from '../../types';

const { home } = menuActions;

const homeRequestEpic = (action$: Observable<Action>, state$: StateObservable<RootState>) => action$.pipe(
  filter(home.request.match),
  filter(() => !isEvoWrappedSelector(state$.value)),
  switchMap((action) => state$.pipe(
    first(),
    filter((s) => (s.config as any)?.widgets?.home
    || (isAuthParamsErrorSelector(state$.value) && !!ss.has('home_url')[1])),
    map(({ config }) => ({ config, action }))
  )),
  switchMap(({ config: { authParams, home, errorCode, general: { language } }, action: { payload = {} } }: any) => {
    const outerLink = payload.outerLink || errorCode !== 0;
    const tableId = tableIdSelector(state$.value);
    const { identifier } = authSelector(state$.value)! || {};

    if (isAuthParamsErrorSelector(state$.value) && ss.has('home_url')[1]) {
      authParams = { ...authParams, homeUrl: ss.get('home_url')[1] };
      home = { ...home, homeMethod: NAVIGATION_METHODS.REPLACE };
    }

    return from(goHome({
      home,
      authParams,
      outerLink,
      tableId,
      identifier,
      language,
    })).pipe(
      catchError((e) => of({ ok: false, message: e.message }))
    );
  }),
  map(({ ok, message, method }: any) => (ok ? home.success({ method }) : home.failure({ message })))
);

const homeRequestOssEpic = (action$: Observable<Action>, state$: StateObservable<RootState>) => action$.pipe(
  filter(home.request.match),
  filter(() => Boolean(isEvoWrappedSelector(state$.value))),
  tap(() => {
    try {
      postMessage({
        event: EVENTS.REQUEST_HOME,
      }, false);
    } catch (error: any) {
      logDevelopmentError(error.message);
    }
  }),
  ignoreElements()
);

export default combineEpics(homeRequestEpic, homeRequestOssEpic);
